export default function AboutSection() {
  const values = [
    {
      icon: "ri-lightbulb-flash-line",
      title: "Innovation First",
      desc: "We push boundaries with each release, adopting the latest iOS technologies to deliver cutting-edge experiences.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Security Focused",
      desc: "Every product is built with a security-first mindset, ensuring user data and privacy are always protected.",
    },
    {
      icon: "ri-team-line",
      title: "Expert Team",
      desc: "Our talented engineers and designers bring deep iOS expertise and a passion for crafting polished applications.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "User-Centric",
      desc: "We obsess over user experience, making complex functionality feel simple and intuitive on every device.",
    },
  ];

  return (
    <section id="about" className="py-28 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 items-start mb-20">
          <div className="flex-1">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">
              // Who We Are
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight max-w-lg">
              Expert Team Building Premium iOS Solutions
            </h2>
          </div>
          <div className="flex-1 pt-4">
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              CERTROM SRL was founded with a clear mission: to deliver modern, reliable, and beautifully crafted applications for the iOS ecosystem. We combine deep technical expertise with a genuine passion for mobile innovation.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Our portfolio focuses on two critical pillars of modern mobile life — security and performance — reflected in our flagship products, VPN and Cleaner.
            </p>
          </div>
        </div>

        {/* Image + Stats */}
        <div className="flex flex-col lg:flex-row gap-8 mb-20">
          <div className="lg:w-1/2 rounded-2xl overflow-hidden" style={{ height: "400px" }}>
            <img
              src="https://public.readdy.ai/ai/img_res/a5309a54160817ce163735245e8fc540.jpg"
              alt="CERTROM SRL team"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="lg:w-1/2 flex flex-col justify-center gap-6">
            {[
              { num: "99.9%", label: "Application Uptime Reliability" },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-6 border-b border-gray-200 pb-6 last:border-0 last:pb-0">
                <span className="text-5xl font-extrabold text-gray-900 w-28 shrink-0">{stat.num}</span>
                <span className="text-gray-500 text-base leading-snug">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl p-7 border border-gray-100">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gray-100 mb-5">
                <i className={`${v.icon} text-xl text-gray-700`} />
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-3">{v.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
